import { styled, TextArea as TamaguiTextArea } from 'tamagui';

import { MICRO_TRANSITION_BORDER } from '@/theme/motion';
import { borderWidth } from '@/theme/tokens.generated';

// TextArea's own equivalent of src/components/input.tsx -- see that
// file's doc comment for why this is a styled() wrapper rather than
// tamagui.config.ts's `defaultProps` (broke shorthand inference
// app-wide) or a per-call-site edit (the fix belongs on the component,
// not the screen). `name: 'TextArea'` keeps
// this wrapper resolving tamagui.config.ts's existing light_TextArea/
// dark_TextArea sub-themes.
// hoverStyle/focusStyle re-declared here for the same reason as
// src/components/input.tsx -- see that file's doc comment. Values
// match @tamagui/input's shared.mjs exactly; only `transition` is new.
// borderRadius: '$xl' matches Input's own base -- see that file's
// doc comment for why both moved off the old 2px "stamped" radius.
export const TextArea = styled(TamaguiTextArea, {
  name: 'TextArea',
  borderRadius: '$md',
  paddingHorizontal: '$4',
  paddingVertical: '$3',
  fontSize: '$body',
  borderWidth: borderWidth.hairline,
  hoverStyle: {
    borderColor: '$borderColorHover',
    transition: MICRO_TRANSITION_BORDER,
  },
  focusStyle: {
    borderColor: '$borderColorFocus',
    // 2px focus ring drawn inward over the 1px border: the box never changes
    // width, so nothing shifts when a field gains focus.
    outlineWidth: borderWidth.control,
    outlineStyle: 'solid',
    outlineColor: '$borderColorFocus',
    outlineOffset: -borderWidth.control,
    transition: MICRO_TRANSITION_BORDER,
  },
});
